import {FIELD_TYPE} from "types/enums";
import {ColumnsEdit} from "types/models/column-table-edit";

const {
  INPUT,
  SELECT,
  DATE,
  CHECKBOX,
  COMBO_BOX,
  NUMBER,
  AUTO_COMPLETE,
  CURRENCY,
} = FIELD_TYPE;
const fieldsInit: any[] = [
  {
    type: INPUT,
    label: "ID",
    name: "id",
    disable: true,
  },
  {
    type: INPUT,
    label: "Tên thuốc",
    name: "name",
    rules: [{required: true, message: "Chưa nhập tên thuốc"}],
  },
  {
    type: INPUT,
    label: "Mã thuốc theo BHYT",
    name: "maThuocBHYT",
    // rules: [{required: true, message: "Chưa nhập tên thuốc"}],
  },
  {
    type: INPUT,
    label: "Mã loại thuốc theo BHYT",
    name: "maLoaiThuocBHYT",
    // rules: [{required: true, message: "Chưa nhập tên thuốc"}],
  },
  {
    type: INPUT,
    label: "Số đăng ký",
    name: "soDangKy",
    // rules: [{required: true, message: "Chưa nhập số đăng ký"}],
  },
  {
    type: COMBO_BOX,
    label: "Đường dùng",
    name: "duongDungId",
  },
  {
    type: COMBO_BOX,
    label: "Loại thuốc",
    name: "loaiThuocId",
  },

  {
    type: COMBO_BOX,
    label: "Nhóm thuốc",
    name: "nhomThuocId",
    // rules: [{required: true, message: "Chưa chọn nhóm thuốc"}],
  },
  {
    type: COMBO_BOX,
    label: "Hoạt chất",
    name: "hoatChatId",
    // rules: [{required: true, message: "Chưa chọn hoạt chất"}],
  },
  {
    type: INPUT,
    label: "Nồng độ/Hàm lượng",
    name: "hamLuong",
    // rules: [{required: true, message: "Chưa nhập nồng độ/hàm lượng"}],
  },
  {
    type: COMBO_BOX,
    label: "Đơn vị chính",
    name: "donViTinhId",
    // rules: [{required: true, message: "Chưa chọn đơn vị tính"}],
  },
  {
    type: COMBO_BOX,
    label: "Dược chính",
    name: "duocChinhId",
  },
  {
    type: COMBO_BOX,
    label: "Dạng bào chế",
    name: "baoCheId",
    // rules: [{required: true, message: "Chưa chọn dạng bào chế"}],
  },

  {
    type: INPUT,
    label: "Nước sản xuất",
    name: "nuocSX",
    // rules: [{required: true, message: "Chưa nhập nước sản xuất"}],
  },
  {
    type: INPUT,
    label: "Hãng sản xuất",
    name: "hangSx",
    // rules: [{required: true, message: "Chưa nhập hãng sản xuất"}],
  },
  {
    type: CURRENCY,
    label: "Bảo hiểm chi trả (VNĐ)",
    name: "bhChiTra",
  },
  {
    type: CHECKBOX,
    label: "Là stend",
    name: "isStend",
    checkbox: [{value: true, label: ""}],
  },
];
const columns: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 80,
    show: true,
    align: "center",
  },
  {
    type: COMBO_BOX,
    dataIndex: "donViChuyenDoi",
    key: "donViChuyenDoi",
    title: "Đơn vị chuyển đổi",
    show: true,
  },
  {
    type: NUMBER,
    dataIndex: "tiLe",
    key: "tiLe",
    title: "Tỉ lệ đơn vị chính",
    show: true,
  },
  {
    type: COMBO_BOX,
    dataIndex: "phepTinh",
    key: "phepTinh",
    title: "Phép tính chuyển đổi",
    show: true,
    options: [
      {value: "Nhân", label: "Nhân"},
      {value: "Chia", label: "Chia"},
    ],
  },
  {
    type: INPUT,
    dataIndex: "description",
    key: "description",
    title: "Mô tả",
    show: true,
  },

  {
    title: "",
    dataIndex: "",
    key: "action",
    align: "center",
    width: 60,
    fixed: "right" as any,
    show: true,
  },
];
export {fieldsInit, columns};
